import { useEffect } from "react";
import { useBlocker } from "react-router-dom";

export const usePrompt = (message: string, blocked?: boolean) => {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    return currentLocation.pathname !== nextLocation.pathname;
  });

  const beforeUnloadHandler = (event: Event) => {
    event.preventDefault();
    event.returnValue = true;
  };

  useEffect(() => {
    if (blocker.state !== "blocked") return;

    if (!blocked || window.confirm(message)) {
      blocker.proceed();
    } else {
      blocker.reset();
    }
  }, [blocker.state]);

  useEffect(() => {
    window.addEventListener("beforeunload", beforeUnloadHandler);
  }, []);
};
